import styles from './FJResourceItemLoading.module.less';
import classNames from 'classnames';

const FJResourceItemLoading = props => {
    const { className = '', style = {} } = props;
    return (
        <div
            className={classNames(styles.box, className)}
            style={style}
            onClick={e => {
                // e.stopPropagation();
            }}
        />
    );
};

export default FJResourceItemLoading;
